// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"18a913e7","529":"e64d33e5","578":"948dcd00","646":"fd9fb335","750":"25856eac","787":"0e93ac1c","810":"308bac2b","816":"8de1946a","973":"2a1f9f40"}[chunkId] + ".chunk.js";
};